<script>
  import { Bar, mixins } from 'vue-chartjs'
  const { reactiveData } = mixins

  export default {
    extends: Bar,
    mixins: [reactiveData],
    props: ['data'],
    mounted () {
      this.renderChart(this.chartData, this.options)
    },
    watch: {
      data: function (newData, oldData) {
        this.chartData = newData.report
        this.options = newData.options
      }
    }
  }
</script>



// WEBPACK FOOTER //
// BarChart.vue?9d22beb0